import { render, staticRenderFns } from "./RewardList.vue?vue&type=template&id=5858644d&scoped=true"
import script from "./RewardList.vue?vue&type=script&lang=js"
export * from "./RewardList.vue?vue&type=script&lang=js"
import style0 from "./RewardList.vue?vue&type=style&index=0&id=5858644d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5858644d",
  null
  
)

export default component.exports